import { render, staticRenderFns } from "./setOverallStatus.vue?vue&type=template&id=6fa98216&scoped=true&"
import script from "./setOverallStatus.vue?vue&type=script&lang=js&"
export * from "./setOverallStatus.vue?vue&type=script&lang=js&"
import style0 from "./setOverallStatus.vue?vue&type=style&index=0&id=6fa98216&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa98216",
  null
  
)

export default component.exports